// frontend\src\pages\Calculators\components\DevelopmentTime\DevelopmentTime.js
import { useState } from "react";
import { toast } from "react-toastify";
import { DEV_TIME_MULTIPLIER, INSTRUCTIONS } from "./constants";

const DevelopmentTime = ({ onCalculate }) => {
  const [inputTime, setInputTime] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleCalculate = () => {
    const timeInSeconds = parseFloat(inputTime);

    if (isNaN(timeInSeconds)) {
      toast.error("Пожалуйста, введите числовое значение времени");
      return;
    }

    if (timeInSeconds <= 0) {
      toast.error("Время должно быть положительным числом");
      return;
    }

    setIsLoading(true);

    // Имитация задержки расчета
    setTimeout(() => {
      const developmentTimeInMinutes = timeInSeconds * DEV_TIME_MULTIPLIER;
      const minutes = Math.floor(developmentTimeInMinutes);
      const seconds = Math.round((developmentTimeInMinutes - minutes) * 60);

      const formattedTime = `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;

      onCalculate(
        <div className="text-center py-3">
          <h5 className="mb-3">Рекомендуемое время проявки</h5>
          <div className="display-4 fw-bold text-primary mb-3">{formattedTime}</div>
          <div className="text-muted">для температуры 20 °C</div>
        </div>
      );

      setIsLoading(false);
    }, 50);
  };

  return (
    <div className="container">
      <h2 className="mb-4">Калькулятор времени проявки</h2>

      <div className="alert alert-info">
        <h6 className="alert-heading mb-2">Инструкция:</h6>
        <ul className="mb-0">
          {INSTRUCTIONS.map((step, index) => (
            <li key={index}>{step}</li>
          ))}
        </ul>
        <br/>
        <strong>Совет:</strong> Для точности повторите измерение 2-3 раза
      </div>
      
      <div className="mb-3">
        <label className="form-label">Время совпадения цвета (секунды):</label>
        <input
          type="number"
          className="form-control"
          value={inputTime}
          onChange={(e) => setInputTime(e.target.value)}
          placeholder="Например: 45"
          min="0.1"
          step="0.1"
        />
      </div>

      <button
        className="btn btn-primary w-100 mb-3"
        onClick={handleCalculate}
        disabled={isLoading || !inputTime}
      >
        {isLoading ? "Вычисляем..." : "Рассчитать время"}
      </button>
    </div>
  );
};

export default DevelopmentTime;